import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import Button from "@mui/material/Button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { TIP_INFO_PORUKE } from "../../../../enums";

const Index = ({
  refreshPageOnClose,
  onClose,
  dialogActions,
}: {
  refreshPageOnClose?: boolean;
  onClose?: () => void;
  dialogActions?: React.ReactNode;
}) => {
  const { getValues, setValue, watch } = useFormContext();
  const infoPoruka = getValues("infoPoruka");
  const tipInfoPoruke = getValues("tipInfoPoruke");
  const watchField = watch("infoPoruka", "tipInfoPoruke");
  const theme = useTheme();

  const handleClose = () => {
    setValue("infoPoruka", "");

    if (onClose) {
      onClose();
    }

    if (refreshPageOnClose) {
      window.location.reload();
    }
  };

  return (
    <Dialog
      open={infoPoruka ? true : false}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{
          backgroundColor:
            tipInfoPoruke === TIP_INFO_PORUKE.SUCCESS
              ? theme.palette.success.main
              : theme.palette.error.main,
          color: "#fff",
          marginBottom: 24,
          display: "flex",
          alignItems: "center",
        }}
      >
        {tipInfoPoruke === TIP_INFO_PORUKE.SUCCESS ? (
          <CheckCircleOutlineIcon sx={{ mr: 1 }} />
        ) : (
          <ErrorOutlineIcon sx={{ mr: 1 }} />
        )}
        Info
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {infoPoruka}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {dialogActions}
        <Button onClick={handleClose} type={"button"}>
          Zatvori (Close)
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Index;
